/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/naming-convention */
import {
  gql,
  type QueryHookOptions,
  type TypedDocumentNode,
  useQuery,
} from '@apollo/client'
import type { UseCategoryCollection } from '@velasca/types'

interface CategoryConnectionData {
  collection: UseCategoryCollection
}

interface CategoryConnectionVariables {
  handle?: string
}

const GET_CATEGORY: TypedDocumentNode<
  CategoryConnectionData,
  CategoryConnectionVariables
> = gql`
  query Collection($handle: String) {
    collection(handle: $handle) {
      id
      title
      handle
      descriptionHtml
      hasShoes: metafield(namespace: "custom", key: "contains_shoes") {
        value
      }
      isMainCollection: metafield(
        namespace: "custom"
        key: "is_main_collection"
      ) {
        value
      }
      isSubCollection: metafield(
        namespace: "custom"
        key: "is_sub_collection"
      ) {
        value
      }
    }
  }
`

export const useSingleCategory = (
  options: QueryHookOptions<
    CategoryConnectionData,
    CategoryConnectionVariables
  >,
) => {
  const { loading, data, error, fetchMore } = useQuery(GET_CATEGORY, {
    ...options,
    variables: { ...options.variables },
  })

  return { loading, data, error, fetchMore }
}
